import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const valueBack = document.querySelector('.p-value__img--back');
const valueWrap = document.querySelector('.p-value__wrap');

if (valueBack) {
  let valueTl = gsap.timeline({
    scrollTrigger: {
      scrub: 1,
      trigger: valueBack,
      start: 'top top',
      end: () => '+=' + (valueWrap.clientHeight - valueBack.clientHeight + 80),
      // markers: true,
      pin: true,
    }
  })
  
  valueTl.addLabel('start')
  .to(valueBack, {
    keyframes: {
      '0%': {
        opacity: 1,
      },
      
      '90%': {
        opacity: 1
      },
      
      '100%': {
        opacity: 1
      },
    }
  })
}